export default "__VITE_ASSET__CcAPtww2__"